// src/components/ConfirmAlert/ConfirmAlert.tsx
import React from 'react'
import { Button, Modal } from 'react-bootstrap'

interface Props {
  show: boolean
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  variant?: 'primary' | 'danger' | 'warning' | 'success'
  onConfirm: () => void
  onCancel: () => void
}

export default function ConfirmAlert({
  show,
  title = 'ยืนยันการดำเนินการ',
  message,
  confirmLabel = 'ยืนยัน',
  cancelLabel = 'ยกเลิก',
  variant = 'primary',
  onConfirm,
  onCancel,
}: Props) {
  return (
    <Modal show={show} onHide={onCancel} centered backdrop='static'>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ marginBottom: 0 }}>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-secondary' size='sm' onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant={variant} size='sm' onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
